import type { ISiteCapacity, ISiteHeadcount } from '@/interfaces'
import { SiteCapacity, SiteHeadcount } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'
export class SiteCapacityService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}

	async getIndex(params?: object): Promise<ISiteCapacity[]> {
		return this.getData<ISiteCapacity[]>(`${APIEndpoints.siteCapacity}/`, params)
			.then((data) => {
				return data.map((c: ISiteCapacity) => new SiteCapacity(c))
			})
			.catch((err) => {
				throw err
			})
	}

	async get(id: string): Promise<ISiteCapacity> {
		return this.getData<ISiteCapacity>(`${APIEndpoints.siteCapacity}/${id}`)
			.then((data) => {
				return new SiteCapacity(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async add(siteCapacity: SiteCapacity): Promise<ISiteCapacity> {
		const obj = siteCapacity
		console.log(obj)
		return this.postData<SiteCapacity, ISiteCapacity>(`${APIEndpoints.siteCapacity}/add`, obj)
			.then((res) => {
				console.log(res)
				return res as ISiteCapacity
			})
			.catch((err) => {
				console.log('we have an error')
				throw err
			})
	}

	async update(siteCapacity: SiteCapacity): Promise<SiteCapacity> {
		console.log(siteCapacity)
		const obj = siteCapacity
		return this.patchData(`${APIEndpoints.siteCapacity}/update`, obj)
			.then((data) => {
				return new SiteCapacity(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async getHeadcount(): Promise<ISiteHeadcount> {
		return this.getData<ISiteHeadcount>(`${APIEndpoints.siteCapacity}/headcount/`)
			.then((data) => {
				return new SiteHeadcount(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async updateHeadcount(siteHeadcount: SiteHeadcount): Promise<SiteHeadcount> {
		const obj = siteHeadcount
		return this.patchData(`${APIEndpoints.siteCapacity}/headcount/`, obj)
			.then((data) => {
				return new SiteHeadcount(data)
			})
			.catch((err) => {
				throw err
			})
	}
}
